import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import Label from '@/shared/ui/elements/label/Label';
import { getModifiers } from '@/shared/ui/core';

import { SelectStyled } from './Select.styled';

const labelModifiers = ['default', 'required'];

const Select = (
  { options, outLabel, placeholder, modifiers, ...props },
  ref,
) => (
  <>
    {outLabel && (
      <Label
        content={outLabel}
        modifiers={getModifiers(props, labelModifiers)}
      />
    )}
    <SelectStyled innerRef={ref} as="select" {...props}>
      {placeholder && <option value="">{placeholder}</option>}
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </SelectStyled>
  </>
);

Select.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]).isRequired,
    }),
  ),
  placeholder: PropTypes.string,
  outLabel: PropTypes.string,
  modifiers: PropTypes.arrayOf(PropTypes.string),
};

Select.defaultProps = {
  options: [],
  placeholder: '',
  outLabel: '',
  modifiers: [''],
};

export default React.forwardRef((props, ref) => <Field as={Select} ref={ref} {...props} />);
